import React from "react";
import { Box, Button, Divider, Grid } from "@material-ui/core";
import TextFieldHelper from "../../../components/UI/FormHelper/TextFieldHelper";
import FieldDatePicker from "../../../components/Form/FieldDatePicker";
import UserAutoComplete from "../../../components/Form/UserAutoComplete";
import ChequeAddFromRecieverable from "../../../components/Cheque/Add/ChequeAddFromRecieverable";

const ChequeAdvancedSearchFormFields = (props) => {
  const {
    values,
    touched,
    handleChange,
    isValid,
    setFieldTouched,
    setFieldValue,
    handleClose,
    handleSubmit,
    errors,
  } = props;

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <Grid container>
          <Grid item xs={12} md={12}>
            <Box p={1}>
              <TextFieldHelper title={"ID"} fieldName={"id"} {...props} />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <FieldDatePicker
                label={"تاریخ شروع سررسید"}
                fieldName={"due_date_start"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <FieldDatePicker
                label={"تاریخ پایان سررسید"}
                fieldName={"due_date_end"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"شماره چک"}
                fieldName={"cheque_id"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"شماره صیاد"}
                fieldName={"icis"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"مبلغ چک"}
                fieldName={"amount"}
                isNumber={true}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                type={"select"}
                select={true}
                title={"وضعیت"}
                fieldName={"status"}
                {...props}
                options={[
                  {
                    value: "",
                    label: "همه",
                  },
                  {
                    value: "bounced",
                    label: "برگشت خورده",
                  },
                  {
                    value: "returned-settlement",
                    label: "عودتی - تسویه",
                  },
                  {
                    value: "returned-unresolved",
                    label: "عودتی - بلاتکلیف",
                  },
                  {
                    value: "cashed",
                    label: "پاس شده",
                  },
                ]}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <UserAutoComplete
                disabledAdd={true}
                title={"صاحب چک"}
                fieldName={"first_party_id"}
                fieldNameShow={"first_party_fullname"}
                setFieldValue={setFieldValue}
                value={values.first_party_fullname}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box p={1}>
              <UserAutoComplete
                disabledAdd={true}
                title={"در وجه"}
                fieldName={"second_party_id"}
                fieldNameShow={"second_party_fullname"}
                setFieldValue={setFieldValue}
                value={values.second_party_fullname}
              />
            </Box>
          </Grid>

          <Box style={{ width: "100%" }} mb={2} mt={2}>
            <Divider />
          </Box>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <UserAutoComplete
                disabledAdd={true}
                title={"دهنده چک"}
                fieldName={"giver_user_id"}
                fieldNameShow={"giver_user_fullname"}
                setFieldValue={setFieldValue}
                value={values.giver_user_fullname}
              />
            </Box>
          </Grid>

          <ChequeAddFromRecieverable disabledAdd={true} {...props} />
        </Grid>

        <Box mt={2}>
          <Button
            variant={"contained"}
            type="submit"
            size={"large"}
            fullWidth={true}
            color={"primary"}
          >
            جستجوی پیشرفته
          </Button>
        </Box>
      </form>
    </div>
  );
};

export default ChequeAdvancedSearchFormFields;
